import { render, staticRenderFns } from "./LoyaltyStampGift.vue?vue&type=template&id=55081f56&scoped=true&lang=pug&"
import script from "./LoyaltyStampGift.vue?vue&type=script&lang=js&"
export * from "./LoyaltyStampGift.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyStampGift.vue?vue&type=style&index=0&id=55081f56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55081f56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
